import * as S from './styles';
import { useClient } from '@/hooks';
import { RiLogoutBoxLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { DASHBOARD } from '@/constants/systemRoutes';
import { colors } from '@/constants';

interface FloatButtonToTopProps {
  bottom?: number;
}

const FloatButtonToTop = ({ bottom }: FloatButtonToTopProps) => {
  const { selectedClient, logoutClient } = useClient();
  const navigate = useNavigate();

  const onClick = () => {
    logoutClient();
    navigate(DASHBOARD.link);
  };

  if (!selectedClient?.COD_CLIENTE) return null;

  return (
    <S.Row $bottom={bottom} id="selected-client">
      <S.Card>
        <S.CardText>{selectedClient?.COD_CLIENTE}</S.CardText>
      </S.Card>

      <S.Content>
        <S.Text>{selectedClient?.NM_CLIENTE}</S.Text>
      </S.Content>

      <S.Button onClick={onClick}>
        <RiLogoutBoxLine color={colors.brand.white} size={24} />
      </S.Button>
    </S.Row>
  );
};

export default FloatButtonToTop;
